import axios from 'axios';

const trackingService = axios.create({
  baseURL: process.env.API_GATEWAY_BASE_URI,
  timeout: 6000,
  headers: {
    'content-Type': 'application/json',
    'Event-Type': 'trucker_listing',
    Accept: '/',
    'Cache-Control': 'no-cache',
  },
  withCredentials: false,
});

export default trackingService;
